export enum BooleanEntities {
  YES = 'general.yes',
  NO = 'general.no',
}
